import React, { useState } from "react";
import "./Admission_Process.css";
import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";

const Admission_Process = () => {
  const [modalshow, setmodalshow] = useState(false);
  const openModal = () => {
    setmodalshow(true);
    // setExpanded(false);
  };

  return (
    <section className="Admission_Process" id="admissions">
      <div className="container">
        <div className="col_header">
          <h5 className="col_title">Online BCom Admission Process </h5>
        </div>

        <div className="admission_img_wrapper">
          <img
            src="/assets/edtech_assets/images/online_mba/Admission_Process/img-1.webp"
            className="admission_img"
          />
        </div>

        <button onClick={openModal} className="apply_btn">
          Apply Now
        </button>
      </div>

      {/* Modal */}
      <InquiryFormModal
        show={modalshow}
        onHide={() => {
          setmodalshow(false);
          // setExpanded(false);
        }}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </section>
  );
};

export default Admission_Process;
